"use client";

import MagicLinkForm from "@/components/auth/magic-link-form";

export const dynamic = "force-dynamic";

export default function MagicLinkPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-card-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <MagicLinkForm />
      </div>
    </div>
  );
}
